import React from 'react';
import PropTypes from 'prop-types';
import { Label } from '@gasbuddy/react-components';
import { isEmail } from 'react-multi-email';

import ChipList from '../chip-list';

import styles from './styles.css';

export default function EmailChipList({ recipients: recipientsProps, onListChange, error, onErrorChange }) {
  const [recipients, setRecipients] = React.useState(recipientsProps);
  const [recipientsError, setRecipientsError] = React.useState(error);

  React.useEffect(() => {
    setRecipientsError(error);
  }, [error]);

  React.useEffect(() => {
    setRecipients(recipientsProps);
  }, [recipientsProps.length]);

  const handleOnChipListChange = (e) => {
    setRecipients(e);
    if (recipientsError.length) {
      setRecipientsError('');
      onErrorChange('');
    }
    onListChange(e);
  };

  return (
    <Label>
      <span className={styles.labelText}>
            Recipients
        <span className={styles.requiredInput}> *</span>
      </span>
      <ChipList
        placeholder="Add recipients by email. Press enter after each email to add another."
        onChange={handleOnChipListChange}
        values={recipients}
        validator={isEmail}
        errorMessage="Not a valid email"
      />
      {recipientsError && <span className={styles.errorMessage}>{recipientsError}</span>}
    </Label>
  );
}

EmailChipList.propTypes = {
  onListChange: PropTypes.func.isRequired,
  recipients: PropTypes.arrayOf(PropTypes.string),
  error: PropTypes.string,
  onErrorChange: PropTypes.func,
};

EmailChipList.defaultProps = {
  recipients: [],
  error: '',
  onErrorChange: null,
};
